import { getCountryByCode } from "helpers/countries";
import { RegionsTableActions } from "routes/regions/RegionsTableActions";

export const getRegionsTableColumns = ({ onSuccess }) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 50,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
      size: 200,
    },
    {
      header: "Countries",
      id: "Countries",
      accessorKey: "countries",
      enableSorting: false,
      cell: ({ row }) => {
        const countries = row.original.countries || [];
        return countries
          .map(country => getCountryByCode(country)?.text || country)
          .join(", ");
      },
    },
    {
      header: <div></div>,
      id: "Actions",
      enableSorting: false,
      size: 80,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <RegionsTableActions original={row.original} onSuccess={onSuccess} />
      ),
    },
  ];
};

export const getRegionsTableFilters = () => {
  // No filters for regions table currently
  return [];
};
